import * as yup from "yup";

export const updateNoOfSetsSchema = yup.object().shape({
  upper: yup.number().positive().required("Upper set is required"),
  lower: yup.number().positive().required("Lower set is required"),
});
